/**
 * OWL Datetime config
 */
export const MY_NATIVE_FORMATS = {
  fullPickerInput: {
    year: '2-digit',
    month: '2-digit',
    day: '2-digit',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  },
  datePickerInput: { year: '2-digit', month: 'numeric', day: 'numeric' },
  timePickerInput: { hour: 'numeric', minute: 'numeric' },
  monthYearLabel: { year: '2-digit', month: 'short' },
  dateA11yLabel: { year: '2-digit', month: 'long', day: 'numeric' },
  monthYearA11yLabel: { year: '2-digit', month: 'long' },
};
